<template>
  <div
    class="custom-record"
    :class="{ 'custom-read': isNotReadByMe }"
    @click="click"
  >
    <div class="row" v-if="position === 'right'">
      <div class="col-md-10">
        <div class="row">
          <div class="col-md-12 custom-right">
            <span class="custom-from">{{ from }}</span>
          </div>
          <div class="col-md-12">
            <span class="custom-created-right">{{ created }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <img :src="avatar" class="custom-avatar-right" :alt="avatar" />
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-2">
        <img :src="avatar" class="custom-avatar" :alt="avatar" />
      </div>
      <div class="col-md-10">
        <div class="row">
          <div class="col-md-12">
            <span class="custom-from">{{ from }}</span>
          </div>
          <div class="col-md-12">
            <span class="custom-created">{{ created }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-1">
      <div class="col-md-12">
        <span v-html="message" class="custom-message-preview"></span>
      </div>
      <i v-if="isAttachments" class="fas fa-paperclip custom-clip"></i>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'message-record',
  props: {
    msg: {
      type: Object,
      default: null,
    },
    tags: {
      type: Array,
      default: null,
    },
  },
  computed: {
    avatar() {
      let _data = null
      if (this.msg) {
        var timestamp = new Date().getTime()
        _data = `${this.msg.avatar}?t=${timestamp}`
      }
      return _data
    },
    from() {
      let _data = null
      if (this.msg !== undefined && this.msg !== null) {
        _data = this.msg.name
      }
      return _data
    },
    created() {
      let _data = null
      if (this.msg !== undefined && this.msg !== null) {
        let ago = moment(this.msg.created).fromNow()
        let checkFor = ['second', 'minute', 'hour']
        let isThere = checkFor.some((x) => ago.includes(x))
        if (isThere) {
          _data = ago
        } else {
          _data = `${ago}, ${moment(this.msg.created).format('MM/DD/YYYY')}`
        }
      }
      return _data
    },
    message() {
      let _data = null
      if (this.msg !== undefined && this.msg !== null) {
        _data = this.msg.text
        if (this.tags) {
          this.tags.forEach((element) => {
            if (_data.indexOf(element.value) >= 0) {
              let replacewith = ''
              switch (element.value) {
                case '*|FirstName|*':
                  replacewith = this.msg.to.firstName
                  break
                case '*|LastName|*':
                  replacewith = this.msg.to.lastName
                  break
                // case '*|Calories|*':
                //   replacewith = this.msg.to.calories
                //   break
                // case '*|PercentGoal|*':
                //   replacewith = this.msg.to.percentGoal
                //   break
              }
              if (replacewith !== '') {
                _data = _data.replaceAll(element.value, replacewith)
              }
            }
          })
        }
        if (_data.length > 80) {
          _data = _data.substring(0, 80) + ' ...'
        }
      }
      return _data
    },
    starred() {
      let _data = false
      if (this.msg !== undefined && this.msg !== null) {
        if (this.msg.starred === 1) {
          _data = true
        }
      }
      return _data
    },
    isNotRead() {
      let _data = false
      if (this.msg !== undefined && this.msg !== null) {
        _data = !this.msg.isread
      }
      return _data
    },
    isNotReadByMe() {
      let _data = false
      if (this.msg !== undefined && this.msg !== null) {
        _data = !this.msg.isreadByMe
      }
      return _data
    },
    position() {
      let _data = ''
      if (this.msg !== undefined && this.msg !== null) {
        _data = this.msg.position
      }
      return _data
    },
    isAttachments() {
      let _data = false
      if (this.msg !== undefined && this.msg !== null) {
        if (this.msg.attachments !== null) {
          _data = true
        }
      }
      console.log('Any Attachments', _data)
      return _data
    },
  },
  methods: {
    click() {
      console.log('message record clicked')
      this.$emit('view')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-record {
  cursor: pointer;
  position: relative;
  width: 100%;
  padding: 5px;
  border-bottom: 1px solid #dee2e6;
}
.custom-record:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
.custom-avatar {
  border-radius: 50%;
  width: 34px;
  height: 34px;
}
.custom-avatar-right {
  border-radius: 50%;
  width: 34px;
  height: 34px;
  right: 15px;
  position: relative;
}
.custom-from {
  font-size: 0.8em;
}

.custom-created {
  font-size: 0.7em;
  font-style: italic;
  position: absolute;
  top: 25px;
}
.custom-created-right {
  font-size: 0.7em;
  font-style: italic;
  position: absolute;
  top: 25px;
  right: 60px;
}
.custom-read {
  border-left: 3px solid orangered;
  background-color: rgba(255, 182, 87, 0.2);
}
.custom-right {
  text-align: right;
}
.custom-clip {
  font-size: 0.7em;
  position: absolute;
  left: -10px;
  top: 2px;
  color: gray;
}
</style>
